import {useNavigate} from "react-router-dom";

import {SectionCardHeaderAction, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import {SisbagalSectionCard} from "sisbagal/auth";

const EDARTratamentoLodosSection = ({edar}) => {
    const navigate = useNavigate();

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                navigate(`lodos/edit`);
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Lodos" secondaryActions={secondaryActions}>
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Tipo de tratamento:"
                        value={edar.lodos_tipo_tratamiento_label}
                        tooltipText="Tipoloxías de tratamentos de lodos"
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Dixestión anaerobia:"
                        value={edar.dixestion_anaerobia_label}
                        tooltipText="Existe dixestión anaerobia como estabilización dos lodos na planta?"
                    />
                </Grid>
            </Grid>
        </SisbagalSectionCard>
    );
};

export default EDARTratamentoLodosSection;
